module.exports = __webpack_public_path__ + "static/media/background.f524c5f2.jpg";